import React, { useContext, useEffect, useState } from 'react';
import { getDatabase, ref, get, query, orderByChild, equalTo } from 'firebase/database';
import { useLocation } from 'react-router-dom';
import Nav from '../CreatorComponents/Nav';
import { EmbeddedComponentWrapper } from '../CreatorComponents/EmbeddedComponentWrapper';
import DataRequest from '../CreatorComponents/DataRequest';
import Screen from '../CreatorComponents/Screen';
import { AuthUserContext } from '../../../session';
import { CSpinner } from '@coreui/react';

const CreatorDashboardLayout = ({ children }) => {
      const location = useLocation();
      const authContext = useContext(AuthUserContext);
      const [stripeAccountId, setStripeAccountId] = useState(null);
      const [isLoading, setIsLoading] = useState(true);
      
      console.log('CreatorDashboardLayout render:', {
            pathname: location.pathname,
            authContext,
            stripeAccountId,
            isLoading,
            hasChildren: !!children
      });

      useEffect(() => {
            let mounted = true;

            const fetchStripeAccount = async () => {
                  if (!authContext?.authUser?.email) {
                        console.log('No auth user email, skipping fetch');
                        return;
                  }
                  
                  try {
                        setIsLoading(true);
                        console.log('Fetching stripe account for:', authContext.authUser.email);
                        const db = getDatabase();
                        const creatorsRef = ref(db, 'verified_creators');
                        const emailQuery = query(
                              creatorsRef,
                              orderByChild('email'),
                              equalTo(authContext.authUser.email)
                        );

                        const snapshot = await get(emailQuery);
                        if (snapshot.exists() && mounted) {
                              const creatorData = Object.values(snapshot.val())[0];
                              console.log('Found stripe account:', creatorData.stripeAccountId);
                              setStripeAccountId(creatorData.stripeAccountId);
                        }
                  } catch (error) {
                        console.error('Error fetching Stripe account:', error);
                  } finally {
                        if (mounted) {
                              setIsLoading(false);
                        }
                  }
            };

            fetchStripeAccount();

            return () => {
                  mounted = false;
            };
      }, [authContext]);

      if (isLoading) {
            return (
                  <div className="min-h-screen bg-gray-50">
                        <Nav />
                        <div className="text-center p-5">
                              <CSpinner />
                              <p className="mt-3">Loading dashboard...</p>
                        </div>
                  </div>
            );
      }

      return (
            <div className="min-h-screen bg-gray-50">
                  <Nav />
                  <div className="flex-1 p-4">
                        <EmbeddedComponentWrapper accountId={stripeAccountId}>
                              <DataRequest>
                                    <Screen>
                                          {React.Children.map(children, child => {
                                                if (React.isValidElement(child)) {
                                                      return React.cloneElement(child, {
                                                            authUser: authContext,
                                                            stripeAccountId,
                                                      });
                                                }
                                                return child;
                                          })}
                                    </Screen>
                              </DataRequest>
                        </EmbeddedComponentWrapper>
                  </div>
            </div>
      );
};

export default CreatorDashboardLayout; 